<template>
  <div>
    <v-text-field
      :value="infoText"
      readonly
      @mouseup="onClick"
    />
    <v-dialog :persistent="true" v-model="selected" max-width="30%" eager>
      <v-card>
        <v-card-text>
          <project-select
            v-model="project"
            validationsOff
          />
          <v-text-field
            label="Haushaltsstelle"
            v-model="haushaltsstelle"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" text @click="clearSelection">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn color="primary" text @click="selected = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import ProjectSelect from '../projekte/ProjectSelect';
import _ from "lodash";

export default {
  name: 'ProjectFilter',
  components: {
    ProjectSelect,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    haushaltsstelle(value) {
      this.onHaushaltsstelleChange(value);
    },
    project(value) {
      this.$emit('changed', { ...value, haushaltsstelle: this.haushaltsstelle });
    }
  },
  computed: {
    infoText() {
      if (!this.haushaltsstelle && (!this.project || !this.project.product)) {
        return 'Suche...';
      } else if(!this.project || !this.project.product) {
        return this.haushaltsstelle;
      }

      let result = this.project.product;
      if(this.haushaltsstelle) {
        result = `${result} (${this.haushaltsstelle})`;
      }
      if (this.project.order) {
        result = `${result} -> ${this.project.order}`
      }
      if (this.project.activity) {
        result = `${result} -> ${this.project.activity}`
      }

      return result;
    }
  },
  created() {
    // Needed to ensure that multiple instances of project filter can be used side by side
    this.onHaushaltsstelleChange = _.debounce((value) => this.$emit('changed', { ...this.project, haushaltsstelle: value }), 1000);
  },
  methods: {
    clear() {
      this.project = null;
      this.clearSelection();
    },
    clearSelection() {
      this.haushaltsstelle = null;
    },
    onClick() {
      if (this.disabled) {
        return;
      }

      if (!this.selected) {
        this.selected = true;
      }
    },
    onHaushaltsstelleChange() {},
  },
  data() {
    return {
      project: null,
      haushaltsstelle: null,
      selected: false,
    };
  },
};
</script>
